import React from 'react';

export const DropdownContext = React.createContext({
  direction: 'down',
  nav: false,
  open: false,
  toggle() {},
});
